define({
    TEXT_AND_ICON: "TEXT_AND_ICON",
    TEXT_ONLY: "TEXT_ONLY",
    ICON_ONLY: "ICON_ONLY"
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/button/ButtonType.js